import React, { useState, useEffect } from "react";
import { HomeDesktop } from "./HomeDesktop";
import MediaQuery from "react-responsive";
import { HomeMobile } from "./HomeMobile";
import { _gtag, getIsTestAcc} from "helpers/GlobalHelper"
import { setProvider, resetProvider, getProvider } from "helpers/getProviderConfigHelper"
export const Home = (props) => {

  _gtag(`landing_screen`);

  const [providerSelected, setProviderSelected] = useState(false)
  const [generalProps, setGeneralProps] = useState({
    history: props.history,
    ...getProvider()
  });

  const configureProvider = (provider) => {

    if( !provider ) {
      setGeneralProps({
        ...generalProps,
        hasProvider: false,
        provider: null
      });
      resetProvider();
      setProviderSelected(false)
      return;
    }

    setGeneralProps({
      ...generalProps,
      hasProvider: true,
      provider: provider,
      name: provider
    });
    setProvider(provider, {});
    setProviderSelected(true)
  }
  const path = props.history.location.pathname.toString().toLowerCase();
  useEffect(() => {
    switch (path) {
      case '/yoodo':
        configureProvider('yoodo');

        break;
      case '/indosat':
        configureProvider('indosat');
        break;
      case '/business':
        configureProvider('business');
        break;
      case '/business-dashboard':
        configureProvider('business-dashboard');
        break;
      default:
        configureProvider(null);
        break;
    }
  }, []);

  useEffect(() => {
    const isTestAcc = getIsTestAcc();
    document.title = `${isTestAcc ? '[TEST] - ' : ''}${document.title}`;
  }, []);


  return (
    <div>
      {
        path == '/business-dashboard' || path == '/business' ? (
          <HomeDesktop {...generalProps} />
        ) : (<>
          <MediaQuery maxWidth={775}>
            <HomeMobile {...generalProps} />
          </MediaQuery>
          <MediaQuery minWidth={776}>
            <HomeDesktop {...generalProps} />
          </MediaQuery>
        </>)
      }
    </div>
  );
};
